module.exports = __webpack_public_path__ + "media/02-sol-norepinephrine.c597ac71.mp4";